<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'storage-invoices-confirm.allInvoices' | transloco }}
      </h3>
    </div>
    <div>
      <button (click)="paidConfirm()"
              [disabled]="isLoading.paid"
              [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.paid}"
              type="button"
              class="btn btn-outline-warning m-btn m-btn--icon m--margin-right-10"
              [title]="'storage-invoices-confirm.btn.paid' | transloco">
        <span>
          <i class="la la-money-bill"></i>
          <span>{{ 'storage-invoices-confirm.btn.paid' | transloco }}</span>
        </span>
      </button>
    </div>
    <div>
      <button routerLink="new"
              type="button"
              class="btn btn-success m-btn m-btn--icon m--margin-right-10"
              [title]="'storage-invoices-confirm.btn.newPaid' | transloco">
        <span>
          <i class="la la-plus"></i>
          <span>{{ 'storage-invoices-confirm.btn.newPaid' | transloco }}</span>
        </span>
      </button>
    </div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'storage-invoices-confirm.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
            <div class="filter">
              <small>{{ 'storageinvoice.searchByNumber' | transloco }}</small>
              <input type="text" required [(ngModel)]="params.query" (keyup)="onQueryChanged()" name="fiscalNumber"
                     class="form-control m-input" [placeholder]="'storageinvoice.searchByNumber' | transloco">
            </div>
            <div class="filter">
              <small>{{ 'storageinvoice.searchByStoreProduct' | transloco }}</small>
              <hx-product-info-select [(ngModel)]="params.productInfoIds" [isPurchasable]="true" [multiple]="true" [brandIds]="brandIds"
                                      (selectChange)="applyFilters()"></hx-product-info-select>
            </div>
            <div class="filter">
              <small>{{ 'storageinvoice.createDate' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.createDate" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storageinvoice.incomingDate' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.incomingDate" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storageinvoice.paidDate' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.paidDate" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storageinvoice.dueDate' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.dueDate" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storage.invoice.supplier' | transloco }}</small>
              <app-suppliers-search [(ngModel)]="params.supplierId" [storeIds]="params.storeIds" (selectChange)="onSupplierChanged()"></app-suppliers-search>
            </div>

            <div class="filter">
              <small>{{ 'storage.invoice.status' | transloco }}</small>
              <hx-enum-select [(ngModel)]="params.statuses" enumName="StorageInvoiceStatus" [enumType]="StorageInvoiceStatus" [multiple]="true" (selectChange)="applyFilters()"></hx-enum-select>
            </div>

            <div class="filter">
              <small>&nbsp;</small>
              <hx-checkbox [(ngModel)]="params.paid" label="filter.paid" (valueChange)="applyFilters()"></hx-checkbox>
            </div>
          </div>

          <div class="row" style="text-align: right">
            <div class="col-md-12">
              <button type="button" (click)="resetFilter()" class="btn btn-outline-primary">
                <span>{{ 'reset.list' | transloco }}</span>
              </button>
            </div>
          </div>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-20 m--margin-bottom-30"
            *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <label class="m-checkbox m--margin-left-3" (change)="checkAll()">
                    <input type="checkbox" [(ngModel)]="isAll">
                    <span></span>
                  </label>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.num' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.number' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.shop' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.createData' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.data' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.status' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.dataPaid' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'storage-invoices-confirm.supplier' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-right">
                  <span>{{ 'storage-invoices-confirm.sum' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <label class="m-checkbox" (change)="toggleStorageInvoice(item)">
                    <input [disabled]="item.paymentDate" type="checkbox" [name]="'checkbox_' + item.id"
                           [checked]="item.selected">
                    <span></span>
                  </label>
                </td>
                <td class="m-datatable__cell">
                  <a *ngIf="item.status !== 'SENT'" [routerLink]="[item.id]">
                    {{ item.number }}
                  </a>
                  <a *ngIf="item.status === 'SENT'" [routerLink]="['received', item.id]">
                    {{ item.number }}
                  </a>
                </td>
                <td class="m-datatable__cell">
                  <a *ngIf="item.status !== 'SENT'" [routerLink]="[item.id]">
                    {{ item.incomingInvoiceNumber }}
                  </a>
                  <a *ngIf="item.status === 'SENT'" [routerLink]="['received', item.id]">
                    {{ item.incomingInvoiceNumber }}
                  </a>
                </td>
                <td class="m-datatable__cell">
                  {{ item.store.title | uiLabel }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.createDate | date:'dd.MM.yy HH:mm' }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.incomingInvoiceDate | date:'dd.MM.yy' }}
                </td>
                <td class="m-datatable__cell text-nowrap">
                  <span class="m-badge m-badge--wide m-badge--rounded"
                        [ngClass]="'m-badge--' + statusList[item.status]?.badge">
                    {{ 'hx.enum.StorageInvoiceStatus.' + item.status | transloco }}
                  </span>
                </td>
                <td class="m-datatable__cell">
                  {{ item.paymentDate | date:'dd.MM.yyyy HH:mm' }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.supplier?.name }}
                </td>
                <td class="m-datatable__cell text-nowrap text-right">
                  {{ item.totalPrice | uiCurrency:item.currency }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit"
                            (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
